import { UI_PERMISSION } from "@/core/utils/access/permissionConstants"
import { useFeatureFlag } from "@/hooks/useFeatureFlag"
import usePermissions from "@/hooks/userPermission"

/**
 * Scanner module access guard.
 *
 * Returns true only when BOTH conditions are met:
 *  1. The "enable-scanner-module" feature flag is ON in the current environment.
 *  2. The authenticated user has the UI_MODULE_SCANNER backend permission.
 *
 * This prevents the scanner UI from being revealed by flipping the flag
 * via browser DevTools — the backend permission remains the authoritative gate.
 */
export const useScannerAccess = (): boolean => {
  const isFlagEnabled = useFeatureFlag("enable-scanner-module")
  const { hasAny } = usePermissions()
  return isFlagEnabled && hasAny(UI_PERMISSION.UI_MODULE_SCANNER)
}
